import { NextSeo } from 'next-seo';
import PropTypes from 'prop-types';

const ArticlesByTagCategoryHead = ({ category = null, tag = null }) => (
  <NextSeo
    description={`Blog do Promobit. Dicas sobre ${
      category || tag
    }, consumo, notícias e análises de produtos.`}
    openGraph={{
      title: `Arquivos ${category || tag} | Promobit`,
      description: `Blog do Promobit. Dicas sobre ${
        category || tag
      }, consumo, notícias e análises de produtos.`,
    }}
    title={`Arquivos ${category || tag} | Promobit`}
  />
);

ArticlesByTagCategoryHead.propTypes = {
  category: PropTypes.string,
  tag: PropTypes.string,
};

export default ArticlesByTagCategoryHead;
